import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
//
import { useGetCurrentUserQuery } from '../store/api/user.api';
import { useGetPlatformSettingsQuery } from '../store/api/transaction.api';

export default function AuthorizedLayout() {
  const isAuthorized = useSelector((state) => !!state.auth.authToken);
  const { isLoading, isSuccess, isError } = useGetCurrentUserQuery(undefined, {
    skip: !isAuthorized,
  });
  // pre-populating balance query if user successfully loaded
  useGetPlatformSettingsQuery(undefined, { skip: !isAuthorized || !isSuccess });

  // if cookie is missing or user loading failed - sending them back to login page
  if (!isAuthorized || isError) {
    return <Navigate to='/login' />;
  }
  // if user is loading - show nothing (maybe show loading indicator?)
  if (isLoading) {
    return <></>;
  }
  // otherwise, continue with app
  return <Outlet />;
}
